/**
 * Typed API client.
 *
 * `paths` comes from schema.d.ts, which is generated from the backend's
 * OpenAPI schema by `make types`. A wrong path, a wrong method, or a wrong
 * request body shape is a tsc error, not a runtime 422.
 *
 * Do not hand-edit schema.d.ts. Change the Pydantic model and run `make types`.
 */
import createClient from 'openapi-fetch';
import type { paths } from './schema';

/**
 * Empty locally (Vite proxies /api to the backend on :5173's origin), and the
 * full API host when deployed. One code path, three environments.
 */
const baseUrl = import.meta.env.VITE_API_BASE_URL ?? '';

export const api = createClient<paths>({ baseUrl });

/**
 * Tag every request with an id the backend binds to all of its log lines and
 * echoes back. Faro reports the same id from the browser side, so one id out of
 * a user report finds both halves of the story in Loki.
 */
api.use({
  onRequest({ request }) {
    if (!request.headers.get('X-Request-Id')) {
      request.headers.set('X-Request-Id', crypto.randomUUID());
    }
    return request;
  },
});

export const APP_ENV = import.meta.env.VITE_APP_ENV ?? 'local';
